import { ApolloClient, InMemoryCache } from "@apollo/client";
import constants from "src/constants";
import getCookieByName from "src/functions/getCookieByName";
import validateAuthToken from "src/functions/validateAuthToken";

const token = validateAuthToken(getCookieByName(`auth-token`));

let clientProps = {
  uri: constants.Paths.apiUrl + "/graphql",
  cache: new InMemoryCache(),
  headers: null,
};

if (token !== null) {
  clientProps.headers = token;
}

const graphQLClient = new ApolloClient(clientProps);

export default graphQLClient;
